import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
import SimpleLayout from 'src/layouts/simple';
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';
import RegisterLayout from 'src/layouts/register-layout';
import AuthGuard from 'src/auth/guard/auth-guard';
import { RoleBasedGuard } from 'src/auth/guard';
import JwtHeightLoginView from 'src/sections/auth/jwt/jwt-height-login-view';


// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('src/pages/home'));
const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const FaqsPage = lazy(() => import('src/pages/faqs'));
const AboutPage = lazy(() => import('src/pages/about-us'));
const ContactPage = lazy(() => import('src/pages/contact-us'));
const PricingPage = lazy(() => import('src/pages/pricing'));
const PaymentPage = lazy(() => import('src/pages/payment'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));
// STUDENT PAYMENT
const StudentPaymentPage = lazy(() => import('src/pages/payment student'));
// PRODUCT
const ProductListPage = lazy(() => import('src/pages/product/list'));
const ProductDetailsPage = lazy(() => import('src/pages/product/details'));
const ProductCheckoutPage = lazy(() => import('src/pages/product/checkout'));
// BLOG
const PostListPage = lazy(() => import('src/pages/post/list'));
const PostDetailsPage = lazy(() => import('src/pages/post/details'));
// STUDENT EXAMINATION
const TestPage = lazy(() => import('src/pages/dashboard/tests/test'));
// HEIGHT STUDENT EXAMINATION
const HeightTestPage = lazy(() => import('src/pages/dashboard/HEIGHT-tests/test'));

// TEST SUBMIT
const SubmitView = lazy(() => import('src/pages/submit'));
// TIMEOUT
const TimeOutPage = lazy(() => import('src/pages/timeout'));
// INSTRUCTIONS
const ReattemptInstructions = lazy(() => import('src/sections/reattempts/reattempt-instructions'));
const ReattemptTest = lazy(() => import('src/sections/reattempts/reattempt-test'));
const InstructionPage = lazy(() => import('src/pages/dashboard/tests/instruction-view'));
// HEIGHT INSTRUCTIONS
const HeightInstructionPage = lazy(() => import('src/pages/dashboard/HEIGHT-tests/instruction-view'));

// TALENT HUNT REGISTRATION
const HeightRegistrationCreatePage = lazy(() => import('src/pages/dashboard/height-student/create'));
//
const ICICIPaymentPage = lazy(() => import('src/pages/ICICIpayment'));
const ICICIExamPaymentPage = lazy(() => import('src/pages/ICICIExampayment'));
//
const SuccessPaymentView = lazy(() => import('src/pages/successpayment'));
// 
const StudentCreatePage = lazy(() => import('src/pages/dashboard/student/newstudentoutsidelogin'));
const StudentRegisterPage = lazy(() => import('src/pages/dashboard/student/register'));
const VerifyEmailPage = lazy(() => import('src/pages/auth/verify-email'));
const ExaminationReportPage = lazy(() => import('src/pages/examination-report'));
const GuestRegisterPage = lazy(() => import('src/pages/auth/guest-register'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['student']} hasContent>
          <SimpleLayout>
            <Suspense fallback={<SplashScreen />}><Outlet /></Suspense>
          </SimpleLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { path: 'reattempt/instruction/:quizId', element: <ReattemptInstructions /> },
      { path: 'reattempt/:attemptId/test', element: <ReattemptTest /> },
    ],
  },
  // {
  //   element: (
  //     <MainLayout>
  //       <Suspense fallback={<SplashScreen />}>
  //         <Outlet />
  //       </Suspense>
  //     </MainLayout>
  //   ),
  //   children: [
  //     { path: 'about-us', element: <AboutPage /> },
  //     { path: 'contact-us', element: <ContactPage /> },
  //     { path: 'faqs', element: <FaqsPage /> },
  //     {
  //       path: 'product',
  //       children: [
  //         { element: <ProductListPage />, index: true },
  //         { path: 'list', element: <ProductListPage /> },
  //         { path: ':id', element: <ProductDetailsPage /> },
  //         { path: 'checkout', element: <ProductCheckoutPage /> },
  //       ],
  //     },
  //     {
  //       path: 'post',
  //       children: [
  //         { element: <PostListPage />, index: true },
  //         { path: 'list', element: <PostListPage /> },
  //         { path: ':title', element: <PostDetailsPage /> },
  //       ],
  //     },
  //   ],
  // },
  {
    element: (
      <SimpleLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </SimpleLayout>
    ),
    children: [
      // { path: 'pricing', element: <PricingPage /> },
      // { path: 'payment', element: <PaymentPage /> },
      // { path: 'studentpayment', element: <StudentPaymentPage /> },
      { path: 'examination-report/:id', element: <ExaminationReportPage /> },
      { path: 'studentexamination/:id/test', element: <TestPage /> },
      { path: 'studentexamination/instruction/:id/', element: <InstructionPage /> },
      { path: 'submit', element: <SubmitView /> },
      { path: 'the-login', element: <JwtHeightLoginView /> },

      { path: 'student/height/examination/:id/test', element: <HeightTestPage /> },
      { path: 'student/height/examination/instruction/:id/', element: <HeightInstructionPage /> },
      { path: 'height-submit', element: <SubmitView /> },

      { path: 'timeout', element: <TimeOutPage /> },

    ],
  },
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      // { path: 'coming-soon', element: <ComingSoonPage /> },
      // { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
      { path: 'payform', element: <ICICIPaymentPage /> },
      { path: 'payformexam', element: <ICICIExamPaymentPage /> },
       {
        path: 'verify-email',
        element: (
          <AuthGuard>
            <VerifyEmailPage />
          </AuthGuard>
        ),
      },
    ],
  },
  {
    element: (
      <RegisterLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </RegisterLayout>
    ),
    children: [
      { path: 'register/:examId', element: <HeightRegistrationCreatePage /> },
      // { path: 'register', element: <HeightRegistrationCreatePage /> },
      { path: 'guest-register', element: <GuestRegisterPage /> },
      { path: 'course/register', element: <StudentRegisterPage /> },
      { path: 'dashboard/student/register', element: <StudentRegisterPage /> },
      { path: 'successpayment', element: <SuccessPaymentView /> },
      { path: 'studentcreate', element: <StudentCreatePage /> },
    ],
  },
];
